/**
 * Hash non crittografico a 53 bit (cyrb53), restituito come intero sicuro.
 * Mescola i bit a ogni carattere: niente collisioni costruibili come
 * `Aa`/`BB`, che con `hashValue` hanno lo stesso valore. Da usare quando
 * una collisione avrebbe effetti sui dati.
 *
 * Algoritmo di bryc, pubblico dominio:
 * https://github.com/bryc/code/blob/master/jshash/experimental/cyrb53.js
 */
export function cyrb53(value: string): number {
  let h1 = 0xde_ad_be_ef;
  let h2 = 0x41_c6_ce_57;
  for (let index = 0; index < value.length; index++) {
    const code = value.charCodeAt(index);
    h1 = Math.imul(h1 ^ code, 2_654_435_761);
    h2 = Math.imul(h2 ^ code, 1_597_334_677);
  }
  h1 = Math.imul(h1 ^ (h1 >>> 16), 2_246_822_507);
  h1 ^= Math.imul(h2 ^ (h2 >>> 13), 3_266_489_909);
  h2 = Math.imul(h2 ^ (h2 >>> 16), 2_246_822_507);
  h2 ^= Math.imul(h1 ^ (h1 >>> 13), 3_266_489_909);
  // 21 bit di h2 in testa e 32 di h1: 53 bit, entro Number.MAX_SAFE_INTEGER.
  return 4_294_967_296 * (2_097_151 & h2) + (h1 >>> 0);
}
